import { useCallback } from 'react';
import type { QueryParamConfig } from 'use-query-params';
import {
  useQueryParams, StringParam,
  NumberParam,
  encodeString, decodeString,
} from 'use-query-params';
import type { SurveyResponses } from '../interfaces';

type Bucket = SurveyResponses.QueryState.Bucket;

const BucketParam: QueryParamConfig<Bucket, Bucket> = {
  encode: (bucket: Bucket) => bucket ? encodeString(`[${bucket.minValue}-${bucket.maxValue})`) : undefined,
  decode: (bucket: string) => {
    const s = decodeString(bucket);

    if (!s) return null;

    const regex = /\[(-?[0-9]*)-(-?[0-9]*)\)/g;
    const matches = regex.exec(s);

    const minValue = matches[1];
    const maxValue = matches[2];

    if (minValue === undefined || maxValue === undefined) return null;

    return {
      minValue: +minValue,
      maxValue: +maxValue,
    } as Bucket;
  },
};

export const useMatchResponsesStateFromUrl = () => {

  const [query, setQuery] = useQueryParams({
    bucket: BucketParam,
    key: StringParam,
    groupId: NumberParam,
    optionId: NumberParam,
    page: NumberParam,
    projectId: NumberParam,
    questionId: NumberParam,
    rowId: NumberParam,
    attributeId: NumberParam,
    levelId: NumberParam,
    surveyId: NumberParam,
    heatmapType: StringParam,
  });

  const reset = useCallback(() => {
    setQuery({
      bucket: undefined,
      key: undefined,
      groupId: undefined,
      optionId: undefined,
      page: undefined,
      projectId: undefined,
      questionId: query.questionId,
      surveyId: query.surveyId,
      rowId: undefined,
      attributeId: undefined,
      levelId: undefined,
      heatmapType: undefined,
    });
  }, [
    query.questionId,
    query.surveyId,
    setQuery,
  ]);

  return [query, setQuery, reset] as const;
};

export default useMatchResponsesStateFromUrl;